import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';

@Component({
  selector: 'app-new-topic',
  templateUrl: './new-topic.component.html',
  styleUrls: ['./new-topic.component.scss'],
  providers: [
    ]
})
export class NewTopicComponent implements OnInit {
  topicTypeArr = ['Easy', 'Medium', 'Hard'];
  pointsArr = ['1', '2', '3', '4'];
  alphabetExp = '[a-zA-Z ]*$';
  topicName = new FormControl('', [Validators.required]);
  topicType = new FormControl('', [Validators.required]);
  topicList = [];
  constructor(
    public dialogRef: MatDialogRef<NewTopicComponent>, public snackbar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private httpService: HttpService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
      console.log("data topicList", data);

     this.topicList = (data as any);
    console.log('TopicList', this.topicList);

  }

  ngOnInit() {
  }


  getTopicNameErrorMessage() {
    return this.topicName.hasError('required') ? 'Topic Name is required' : '';
  }

  addTopic() {
    if (this.topicType.value == 'Easy') {
      this.topicType.setValue(1)
    }
    else if (this.topicType.value == 'Medium') {
      this.topicType.setValue(2)
    }
    else if (this.topicType.value == 'Hard') {
      this.topicType.setValue(3)
    }
    var data = {
      topicComplexity: this.topicType.value,
      topicName: this.topicName.value
    }
    console.log("Test time Data", data);
    this.spinnerService.show();
    var contentBody = { url: "/topics", body: data }
    this.httpService.httpPost(contentBody, true).subscribe(response => {
      console.log("success ", response);
      this.openSnackBar(response["message"]);
      this.spinnerService.hide();

    }, error => {
      console.log("error ", error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    })
  }
  openSnackBar(message: string) {
    this.snackbar.open(message, null, {
      duration: 2000,
    });
  }

}
